import { router } from "@/routes"
import {
  AcademicCapIcon,
  ChatAlt2Icon,
  HomeIcon,
  SearchIcon,
} from "@heroicons/vue/outline"
import type { NavItem } from "@xy-planning-network/trees"

export const staffBaseNavigation: Array<NavItem> = [
  {
    icon: HomeIcon,
    name: "Dashboard",
    openInTab: false,
    url: router.Staff(),
  },
  {
    icon: SearchIcon,
    name: "Member Directory",
    url: router.Profiles(),
  },
  {
    icon: AcademicCapIcon,
    name: "XYPN Academy",
    openInTab: true,
    url: "/sso/saml2/academy",
  },
  {
    icon: ChatAlt2Icon, // TODO(spk): icon for forums
    name: "XYPN Forums",
    openInTab: true,
    url: "https://community.xyplanningnetwork.com/session/sso",
  },
]
